import { Component } from '@angular/core';

@Component({
  selector: 'sigecom-cities',
  template: `
    <router-outlet></router-outlet>
    <!-- <sigecom-loading/> -->
  `
})
export class CitiesComponent {

}
